import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Row, Col, Input, Button } from 'antd'
import './index.css'
import Logo from 'assets/images/ekko-logo.png'

import { updateProjectName, updateWebsiteUrl, validateSetupProject } from 'redux/OnBoardingNow/actions'

const InputBlock = ({ title, placeholder, value, onChange }) => {
    return (
        <div style={{ paddingTop: 40 }}>
            <h3>{title}</h3>
            <Input placeholder={placeholder} onChange={onChange} value={value}></Input>
        </div>
    )
}

class StepOne extends React.Component {
    onWebsiteUrlChange = e => {
        const value = e.target.value
        const { updateWebsiteUrl } = this.props

        updateWebsiteUrl(value)
    }

    onProjectNameChange = e => {
        const value = e.target.value
        const { updateProjectName } = this.props

        updateProjectName(value)
    }

    onNext = () => {
        const { validateSetupProject } = this.props
        validateSetupProject()
    }

    render() {
        const { websiteUrl, projectName } = this.props

        return (
            <Col xs={22} sm={18} md={14}>
                <img src={Logo} height="42" />
                <h2 style={{ paddingTop: 50, marginBottom: 20 }}>Let us know a bit more about you.</h2>
                <InputBlock
                    title={'Website URL'}
                    placeholder={'Enter your website URL'}
                    onChange={this.onWebsiteUrlChange}
                    value={websiteUrl}
                />
                <InputBlock
                    title={'Project Name'}
                    placeholder={'Enter your project’s name'}
                    onChange={this.onProjectNameChange}
                    value={projectName}
                />

                <div style={{ paddingTop: 80 }}>
                    <Row justify="space-between" type="flex">
                        {/* <Button>Prev</Button> */}
                        <Button type="primary" onClick={this.onNext}>
                            Next
                        </Button>
                    </Row>
                </div>
            </Col>
        )
    }
}

const mapStateToProps = ({ onboarding }) => ({
    websiteUrl: onboarding.websiteUrl,
    projectName: onboarding.projectName
})

const mapActionsToProps = dispatch => ({
    updateProjectName: bindActionCreators(updateProjectName, dispatch),
    updateWebsiteUrl: bindActionCreators(updateWebsiteUrl, dispatch),
    validateSetupProject: bindActionCreators(validateSetupProject, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(StepOne)
